{
  "title": "Commission tiers",
  "add": "Add tier",
  "noLimit": "No limit",
  "created": "Tier created successfully",
  "updated": "Tier updated successfully",
  "deleted": "Tier deleted successfully",
  "statusChanged": "Tier status changed successfully",
  "columns": {
    "name": "Name",
    "from": "From",
    "to": "To",
    "commission": "Commission",
    "status": "Status"
  },
  "rowActions": {
    "trigger": "Actions for {{name}}"
  },
  "statusConfirmTitle": "Change the status of {{name}}",
  "deleteConfirmTitle": "Delete confirmation",
  "deleteConfirmDescription": "The tier \"{{name}}\" will be permanently deleted.",
  "drawer": {
    "createTitle": "Add tier",
    "createDescription": "Enter the new tier's details.",
    "editTitle": "Edit tier",
    "editDescription": "Edit the tier's details.",
    "fields": {
      "name": "Name",
      "noLimit": "No limit",
      "upperLimit": "Upper limit",
      "commission": "Commission"
    }
  },
  "filters": {
    "allStatuses": "All statuses"
  },
  "gaps": {
    "rangeMessage": "No active tier for amounts from {{from}} to {{to}}",
    "aboveMessage": "No active tier for amounts from {{from}} and above"
  },
  "validation": {
    "tooManyDecimals": "At most five decimal places are allowed."
  }
}
